import { useMemo } from "react";
import { Column } from "../../../../common/components/ColumnsSelector/ColumnsSelector";
import { Pricing, PricingStatus, SummaryNames } from "../../pricingListSlice";
import { pricingHasMargin } from "../../pricingList.model";
import { ColumnIds } from "./common";
import * as _ from "lodash";
import { Tender } from "../../../tender_page/tender.module";
import { SupportedCountry } from "../../../../common/constants/countries";

export const pricingListColumns: Column<ColumnIds>[] = [
	{ label: "Tender", id: ColumnIds.TENDER },
	{ label: "GR ID", id: ColumnIds.PGID },
	{ label: "P ID", id: ColumnIds.PID },
	{ label: "PR ID", id: ColumnIds.PRID },
	{ label: "cluster", id: ColumnIds.TOURBILLON_REF },
	{ label: "status", id: ColumnIds.PR_STATUS },
	{ label: "site/port", id: ColumnIds.PR_SITE },
	{ label: "result", id: ColumnIds.PR_ALPHA_OR_BETA },
	{ label: "type name", id: ColumnIds.P_TYPE_NAME },
	{ label: "apply setup fees", id: ColumnIds.APPLY_SET_UP_FEES },
	{ label: "technology", id: ColumnIds.P_TECHNO_NAME },
	{ label: "pricing date", id: ColumnIds.PRICING_DATE },
	{ label: "pricing validity", id: ColumnIds.P_VALIDITY_DATE },
	{ label: "Legal Entity / Book", id: ColumnIds.P_PARTY },
	{ label: "Base", id: ColumnIds.P_BASE_CAPA },
	{ label: "clickability", id: ColumnIds.CLICKABILITY },
	{ label: "Click granularity", id: ColumnIds.CLICKABILITY_GRANULARITY },
	{ label: "delivery period", id: ColumnIds.DELIVERY_PERIOD },
	{ label: "installed capacity", id: ColumnIds.P_INSTALL_CAPA },
	{ label: "Provision type", id: ColumnIds.P_PROVISION_TYPE },
	{ label: "Spot market", id: ColumnIds.P_SPOT_MARKET },
	{ label: "Chapter 51", id: ColumnIds.P_CHAPTER_51 },
	{
		label: "Chapter 51 number of hours",
		id: ColumnIds.P_CHAPTER_51_NUMBER_OF_HOURS,
	},
	{
		label: "pricing.column_selector.negative_price",
		id: ColumnIds.NEGATIVEPRICEVALUE,
	},
	{
		label: "pricing.column_selector.negative_price_conditions",
		id: ColumnIds.NEGATIVE_PRICE_CONDITIONS,
	},
	{
		label: "Curtailability forward conditions",
		id: ColumnIds.CURTAILABILITY_FORWARD_CONDITIONS,
	},
	{ label: "Cap/Floor", id: ColumnIds.CAP_FLOOR },
	{ label: "Settl. period", id: ColumnIds.SETTLEMENT_PERIOD },
	{ label: "Balancing Group", id: ColumnIds.BALANCING_GROUP },
	{ label: "Marketing type", id: ColumnIds.MARKETING_TYPE },
	// End of fixed columns
	{ label: "customer p50", id: ColumnIds.CUSTOMER_P50 },
	{ label: "p50", id: ColumnIds.P50 },
	{ label: "proxy", id: ColumnIds.PROXY },
	{ label: "lf", id: ColumnIds.LF },
	{ label: "qty", id: ColumnIds.QTY },
	{
		label: "pricing.column_selector.goo_power_adjustment_label",
		id: ColumnIds.GOO_ADJ_INPUT,
	},
	{ label: "cross", id: ColumnIds.CROSS },
	{ label: "pricing.column_selector.goo_cross", id: ColumnIds.GOO_CROSS },
	{ label: "pricing.column_selector.goo_adj", id: ColumnIds.GOO_ADJ },
	{ label: "xbc", id: ColumnIds.XBC },
	{ label: "xpc", id: ColumnIds.XPC },
	{ label: "xdpc", id: ColumnIds.XDPC },
	{ label: "p50 prov", id: ColumnIds.P50_PROV },
	{ label: "shape", id: ColumnIds.SHAPE },
	{ label: "margin prov", id: ColumnIds.MARGIN_PROV },
	{ label: "Setup fee", id: ColumnIds.SETUPFEE },
	{ label: "Imbalance cost provision", id: ColumnIds.IMBALANCECOSTPROVISION },
	{ label: "Profile cost provision", id: ColumnIds.PROFILECOSTPROVISION },
	{
		label: "Delta profile cost provision",
		id: ColumnIds.DELTAPROFILECOSTPROVISION,
	},
	{ label: "Shape provision", id: ColumnIds.SHAPEPROVISION },
	{ label: "Shape Bid Ask provision", id: ColumnIds.SHAPEBIDASKPROVISION },
	{ label: "pricing_column.selector.goo_price", id: ColumnIds.GOO_PRICE },

	{ label: "Provision", id: ColumnIds.MARGIN_PROVISION },
	{ label: "Alpha provision", id: ColumnIds.ALPHA_PROVISION },
	{ label: "Beta provision", id: ColumnIds.BETA_PROVISION },

	{ label: "Alpha Baseload Margin", id: ColumnIds.ALPHA_BASELOAD_MARGIN },
	{ label: "Alpha Index Margin", id: ColumnIds.ALPHA_INDEX_MARGIN },
	{ label: "Beta Margin", id: ColumnIds.BETA_MARGIN },

	{ label: "Alpha", id: ColumnIds.ALPHA_BASELOAD },
	{ label: "Alpha Baseload Client", id: ColumnIds.PR_ALPHABASELOADCLIENT },

	{ label: "Alpha Index", id: ColumnIds.ALPHAINDEX },
	{ label: "Alpha Index Client", id: ColumnIds.ALPHA_INDEX_CLIENT },

	{ label: "Beta contract", id: ColumnIds.BETA },
	{ label: "Beta contract Client", id: ColumnIds.BETA_CLIENT },

	{ label: "indic", id: ColumnIds.INDIC },

	{ label: "Indic Client", id: ColumnIds.PR_INDICCLIENT },

	{ label: "Fixing Date Time", id: ColumnIds.PR_FIXING_DT },
	{ label: "Baseload Price", id: ColumnIds.PR_BASELOAD_PRICE },
	{ label: "Baseload Mid", id: ColumnIds.PR_BASELOAD_MID },
	{ label: "Fixing CM", id: ColumnIds.PR_COMMERCIAL_MARGIN },
	{
		label: "pricing.column_selector.goo_commercial_margin",
		id: ColumnIds.FIXINGGOOCOMMERCIALMARGIN,
	},
	{ label: "Fix Price", id: ColumnIds.PR_FIXPRICE },
	{
		label: "pricing.column_selector.goo_final_price",
		id: ColumnIds.FINALGOOPRICE,
	},

	{ label: "Fix Beta", id: ColumnIds.PR_BETAFIX },
	{ label: "Hedge Ratio %", id: ColumnIds.HEDGERATIOPERCENT },
	{
		label: "Total Power Margin",
		id: ColumnIds.TOTALPOWERMARGIN,
	},
	{
		label: "pricing.column_selector.total_goo_margin",
		id: ColumnIds.TOTALGOOMARGIN,
	},
	{ label: "Contract Id", id: ColumnIds.PR_CONTRACT_ID },
	{ label: "Warning", id: ColumnIds.CLEANING_WARNING },
	{ label: "Live pricing used", id: ColumnIds.LIVE_PRICING_WAS_USED },

	// column for US
	{ label: "Is Nodal", id: ColumnIds.IS_NODAL },
	{ label: "Block Shape", id: ColumnIds.BLOCK_SHAPE },
	{ label: "Energy Bid Ask", id: ColumnIds.ENERGY_BID_ASK },
	{
		label: "Production Variability Bid Ask",
		id: ColumnIds.PRODUCTION_VARIABILITY_BID_ASK,
	},
	{ label: "Credit Costs", id: ColumnIds.CREDIT_COSTS },
	{ label: "Pricing Add Ons", id: ColumnIds.PRICING_ADD_ONS },
	{ label: "Shape Type", id: ColumnIds.SHAPE_TYPE },
];

const showColumnIfItHasValueInSummary = (
	pricings: Pricing[],
	summaryName: SummaryNames,
	resultOption?: "alpha" | "beta"
) => {
	return _.some(pricings, (pricing: Pricing) => {
		if (resultOption === "alpha") {
			return (
				!!pricing.pricing_runs?.[0]?.summary?.[summaryName]?.value &&
				pricing.has_alpha
			);
		} else if (resultOption === "beta") {
			return (
				!!pricing.pricing_runs?.[0]?.summary?.[summaryName]?.value &&
				pricing.has_beta
			);
		}
		return !!pricing.pricing_runs?.[0]?.summary?.[summaryName];
	});
};

export function useAvailablePricingListColumns(
	pricings?: Pricing[] | null,
	tender?: Tender
) {
	const showMarginColumns = useMemo(
		() => (pricings?.filter(pricingHasMargin).length || 0) > 0,
		[pricings]
	);

	const showAlphaProvision = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"AlphaProvision",
						"alpha"
				  )
				: false,
		[pricings]
	);

	const showAlphaIndexMargin = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"AlphaIndexMargin",
						"alpha"
				  )
				: false,
		[pricings]
	);

	const showAlphaIndex = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"AlphaIndex",
						"alpha"
				  )
				: false,
		[pricings]
	);

	const showAlphaIndexClient = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"AlphaIndexClient",
						"alpha"
				  )
				: false,
		[pricings]
	);

	const showBetaProvision = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"BetaProvision",
						"beta"
				  )
				: false,
		[pricings]
	);

	const showBetaMargin = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"BetaMargin",
						"beta"
				  )
				: false,
		[pricings]
	);

	const showBeta = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(pricings, "Beta", "beta")
				: false,
		[pricings]
	);

	const showBetaClient = useMemo(
		() =>
			pricings
				? showColumnIfItHasValueInSummary(
						pricings,
						"BetaClient",
						"beta"
				  )
				: false,
		[pricings]
	);

	const showContractId = useMemo(
		() =>
			(pricings?.filter(
				(p) =>
					p.status === PricingStatus.BOOKED ||
					p.status === PricingStatus.BOOKED_MANUALLY
			).length || 0) > 0,
		[pricings]
	);

	const showWarningColumn = useMemo(
		() => _.some(pricings, (pricing) => !!pricing.timeserie?.warning),
		[pricings]
	);

	const showBalancingGroup = useMemo(
		() => _.some(pricings, (pricing) => !!pricing.balancing_group_label),
		[pricings]
	);

	const showMarketingType = useMemo(
		() => _.some(pricings, (pricing) => !!pricing.marketing_type),
		[pricings]
	);

	const showBaseLoadPrice = useMemo(
		() =>
			_.some(
				pricings,
				(pricing) =>
					!!pricing.pricing_runs?.[0]?.summary?.BaseloadPrice?.value
			),
		[pricings]
	);

	const showBaseLoadMid = useMemo(
		() =>
			_.some(
				pricings,
				(pricing) =>
					!!pricing.pricing_runs?.[0]?.summary?.BaseloadMid?.value
			),
		[pricings]
	);

	const showFixingDt = useMemo(
		() =>
			_.some(
				pricings,
				(pricing) =>
					!!pricing.pricing_runs?.[0]?.summary?.FixingDateTime?.value
			),
		[pricings]
	);

	const showFixingCM = useMemo(
		() =>
			_.some(
				pricings,
				(pricing) =>
					!!pricing.pricing_runs?.[0]?.summary?.FixingCommercialMargin
						?.value
			),
		[pricings]
	);

	const showFixPrice = useMemo(
		() =>
			_.some(
				pricings,
				(pricing) =>
					!!pricing.pricing_runs?.[0]?.summary?.FixPrice?.value
			),
		[pricings]
	);

	const showUSRelatedColumns = useMemo(
		() => tender?.countries.includes(SupportedCountry.UNITED_STATES),
		[pricings]
	);

	const mappedColumns = useMemo(() => {
		return pricingListColumns.map((column) => {
			if (
				[
					ColumnIds.PR_ALPHABASELOADCLIENT,
					ColumnIds.PR_INDICCLIENT,
					ColumnIds.ALPHA_INDEX_CLIENT,
					ColumnIds.BETA_CLIENT,
				].includes(column.id)
			) {
				return { ...column, disabled: !showMarginColumns };
			}

			if (
				[
					ColumnIds.IS_NODAL,
					ColumnIds.BLOCK_SHAPE,
					ColumnIds.ENERGY_BID_ASK,
					ColumnIds.PRODUCTION_VARIABILITY_BID_ASK,
					ColumnIds.CREDIT_COSTS,
					ColumnIds.PRICING_ADD_ONS,
				].includes(column.id)
			) {
				return { ...column, disabled: !showUSRelatedColumns };
			}

			if ([ColumnIds.ALPHA_PROVISION].includes(column.id)) {
				return { ...column, disabled: !showAlphaProvision };
			}
			if ([ColumnIds.ALPHA_INDEX_MARGIN].includes(column.id)) {
				return { ...column, disabled: !showAlphaIndexMargin };
			}

			if ([ColumnIds.ALPHAINDEX].includes(column.id)) {
				return { ...column, disabled: !showAlphaIndex };
			}
			if ([ColumnIds.ALPHA_INDEX_CLIENT].includes(column.id)) {
				return { ...column, disabled: !showAlphaIndexClient };
			}
			if ([ColumnIds.BETA_PROVISION].includes(column.id)) {
				return { ...column, disabled: !showBetaProvision };
			}
			if ([ColumnIds.BETA_MARGIN].includes(column.id)) {
				return { ...column, disabled: !showBetaMargin };
			}

			if ([ColumnIds.BETA].includes(column.id)) {
				return { ...column, disabled: !showBeta };
			}
			if ([ColumnIds.BETA_CLIENT].includes(column.id)) {
				return { ...column, disabled: !showBetaClient };
			}

			if ([ColumnIds.PR_FIXING_DT].includes(column.id)) {
				return { ...column, disabled: !showFixingDt };
			}
			if ([ColumnIds.PR_BASELOAD_PRICE].includes(column.id)) {
				return { ...column, disabled: !showBaseLoadPrice };
			}
			if ([ColumnIds.PR_BASELOAD_MID].includes(column.id)) {
				return { ...column, disabled: !showBaseLoadMid };
			}
			if ([ColumnIds.PR_COMMERCIAL_MARGIN].includes(column.id)) {
				return { ...column, disabled: !showFixingCM };
			}
			if ([ColumnIds.PR_FIXPRICE].includes(column.id)) {
				return { ...column, disabled: !showFixPrice };
			}
			if ([ColumnIds.PR_CONTRACT_ID].includes(column.id)) {
				return { ...column, disabled: !showContractId };
			}
			if (column.id === ColumnIds.CLEANING_WARNING) {
				return { ...column, disabled: !showWarningColumn };
			}
			if (column.id === ColumnIds.BALANCING_GROUP) {
				return { ...column, disabled: !showBalancingGroup };
			}
			if (column.id === ColumnIds.MARKETING_TYPE) {
				return { ...column, disabled: !showMarketingType };
			}
			return { ...column, disabled: false };
		});
	}, [
		showMarginColumns,
		showContractId,
		showWarningColumn,
		showBalancingGroup,
		showMarketingType,
		showFixingDt,
		showBaseLoadPrice,
		showBaseLoadMid,
		showFixingCM,
		showFixPrice,
		showAlphaProvision,
		showAlphaIndexMargin,
		showAlphaIndex,
		showAlphaIndexClient,
		showBeta,
		showBetaClient,
		showBetaMargin,
		showBetaProvision,
		showUSRelatedColumns,
	]);

	return mappedColumns;
}
